var map = {
	"./bmw.png": 1241,
	"./ephfero.png": 9376,
	"./explorer-barcelona.png": 982,
	"./explorer-vienna.png": 328,
	"./mft-steel.png": 7818,
	"./mina.png": 4858,
	"./qw.png": 4875,
	"./resabi-logo.png": 1827,
	"./virtuelna-srbija.png": 583,
	"./zanimljiva-srbija.png": 2780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5471;